import { Box, TextField } from '@mui/material';
import { formatDate } from '../utils';

interface OtaDatePickerProps {
  label: string;
  value: string; // yyyy-mm-dd (internal ISO format)
  onChange: (v: string) => void;
  required?: boolean;
  size?: 'small' | 'medium';
  fullWidth?: boolean;
  disabled?: boolean;
  min?: string; // yyyy-mm-dd
  max?: string; // yyyy-mm-dd
}

/**
 * A MUI-styled date picker that always displays dates as dd-MMM-yyyy
 * regardless of the browser's locale, while still using a native
 * <input type="date"> under the hood so the system calendar opens normally.
 *
 * The internal value / API value stays yyyy-mm-dd — only the visible label changes.
 */
export function OtaDatePicker({
  label,
  value,
  onChange,
  required,
  size = 'medium',
  fullWidth,
  disabled,
  min,
  max,
}: OtaDatePickerProps) {
  return (
    <Box sx={{ position: 'relative', display: fullWidth ? 'block' : 'inline-block', width: fullWidth ? '100%' : undefined }}>
      <TextField
        label={label}
        required={required}
        size={size}
        fullWidth={fullWidth}
        disabled={disabled}
        InputLabelProps={{ shrink: true }}
        value={value ? formatDate(value) : ''}
        placeholder="dd-mmm-yyyy"
        inputProps={{ readOnly: true, style: { cursor: disabled ? 'default' : 'pointer' } }}
        
      />
      {!disabled && (
        <Box
          component="input"
          type="date"
          value={value}
          min={min}
          max={max}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
          sx={{
            position: 'absolute',
            inset: 0,
            opacity: 0,
            width: '100%',
            height: '100%',
            cursor: 'pointer',
            border: 'none',
            background: 'transparent',
            zIndex: 1,
            '&::-webkit-calendar-picker-indicator': {
              position: 'absolute',
              inset: 0,
              width: '100%',
              height: '100%',
              opacity: 0,
              cursor: 'pointer',
            },
          }}
        />
      )}
    </Box>
  );
}
